import { modifyMediaUrl } from "../../helpers/modifyMediaUrl";
import VideoPlayer from "../common/VideoPlayer";
import { getCurrentLanguage } from "../../helpers/languageHelper";
import * as videoHelper from "../../helpers/videoHelper";
const VODPlayer = ({ resourceUrl, aspectRatio = "16:9", onPlaybackEvent }) => {
  const vodData = {
    onPlaybackEvent: onPlaybackEvent,
    options: {
      autoplay: false,
      controls: true,
      sources: [
        {
          src: modifyMediaUrl(resourceUrl),
          aspectRatio: aspectRatio,
          type: videoHelper.detectVideoTypeFromUrl(resourceUrl),
        },
      ],
      html5: { vhs: { overrideNative: true } },
      breakpoints: {
        tiny: 300,
        xsmall: 400,
        small: 500,
        medium: 600,
        large: 700,
        xlarge: 800,
        huge: 900,
      },
      plugins: {
        hlsQualitySelector: {
          displayCurrentQuality: true,
        },
      },
      language: getCurrentLanguage(),
      enableSmoothSeeking: true,
      fill: true,
      responsive: true,
      playbackRates: [0.5, 1, 1.5, 2],
      controlBar: {
        skipButtons: {
          forward: 10,
          backward: 10,
        },
      },
    },
  };

  return <VideoPlayer props={vodData} className="border-round-md" />;
};

export default VODPlayer;
